module.exports = __webpack_public_path__ + "img/cup.4696f665.png";